import React from 'react'
import { getEvaluations } from 'api'
import CombinedEvaluationsTable from 'components/Tables'

const AllEvaluationsTable = () => {
  return <CombinedEvaluationsTable fetchData={getEvaluations} dense={true} />
}

export default AllEvaluationsTable
